<template>
  <NavBar />
  <div class="container-scroller">
    <!-- partial -->
    <div class="container-fluid page-body-wrapper">
      <SideNavRight />
      <!-- partial -->
      <div class="main-panel">
        <div>
          <main>
            <router-view />
          </main>
        </div>
        <PageFooter />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import SideNavRight from "@/components/SideNavRight.vue";
import PageFooter from "@/components/Footer.vue";

export default {
  name: "OpenHouse",
  components: {
    NavBar,
    SideNavRight,
    PageFooter,
  },
};
</script>

<style></style>
